'use client';

import { useEffect } from 'react';

export const useAppDidFavorite = (callback?: (pid: string, type: 'add' | 'delete') => void) => {
  useEffect(() => {
    if (typeof window !== 'undefined') {
      globalThis.window.appDidFavorite = (pid: string, type: 'add' | 'delete') => {
        callback?.(pid, type);
      };
    }
  }, [callback]);
};
